import React, { useState, useEffect } from 'react';
import { fetchItems } from "../api/api";
import Table from 'react-bootstrap/Table';
import "../ui/itemrows.css"

const ItemRows = ({ onSelectItem, selectedItemId, search = "" }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const fetchedItems = await fetchItems();
          setItems(fetchedItems);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching items:', error);
        }
      };

      fetchData();
    }, []);

    // Filter items by search
    const filteredItems = items.filter(item =>
        item.name.toLowerCase().includes(search.toLowerCase())
    );

    if (loading) return <div className="item-rows" style={{ padding: "0 0 0 0", background: "transparent" }}>
        <Table
            striped
            hover
            size="sm"
            style={{
                background: "#fafbfc",
                border: "none",
            }}
            ><tbody><td style={{ color: "#bbb", textAlign: "center", padding: "24px 0", marginBottom: 0,
                borderRadius: 8,
                overflow: "hidden" }}>
                    Loading...
            </td></tbody></Table></div>;

    return (
        <div className="item-rows" style={{ padding: "0 0 0 0", background: "transparent" }}>
            <Table
                striped
                hover
                size="sm"
                style={{
                    background: "#fafbfc",
                    border: "none",
                    marginBottom: 0,
                    borderRadius: 8,
                    overflow: "hidden"
                }}
            >
                <tbody>
                    {filteredItems.length === 0 ? (
                        <tr>
                            <td style={{ color: "#bbb", textAlign: "center", padding: "24px 0" }}>
                                No items found
                            </td>
                        </tr>
                    ) : (
                        filteredItems.map(item => (
                            <tr
                                key={item.id}
                                style={{
                                    cursor: 'pointer',
                                    background: selectedItemId === item.id ? '#e6f0ff' : '#fafbfc',
                                    borderLeft: selectedItemId === item.id ? "4px solid #1976d2" : "4px solid transparent",
                                    transition: "background 0.15s, border 0.15s"
                                }}
                                onClick={() => onSelectItem(item.id)}
                                onMouseOver={e => e.currentTarget.style.background = selectedItemId === item.id ? '#e6f0ff' : '#f0f4fa'}
                                onMouseOut={e => e.currentTarget.style.background = selectedItemId === item.id ? '#e6f0ff' : '#fafbfc'}
                            >
                                <td style={{ padding: "12px 18px", fontSize: 15, color: "#222" }}>
                                    {item.name}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default ItemRows;